import {
  Box,
  Button,
  IconButton,
  SxProps,
  Theme,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { format } from "date-fns";
import moment from "moment-timezone";
import { eventTimeFormat } from "utils/dateUtils";
import { FormattedMessage as T, useIntl } from "react-intl";
import { LiveOnlineCourseModel } from "services/organizationPortalClient";
import CreditsCell from "pages/CourseCatalog/CreditsCell";
import { Link } from "react-router-dom";
import useGlobalContext from "hooks/globalData";

const useStyles = (theme: Theme): { [key: string]: SxProps } => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "start",
  },
  title: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
    m: 2,
  },
  content: {
    fontSize: "smaller",
    mb: 1,
  },
});

type CalendarEventProps = {
  event: LiveOnlineCourseModel;
  onClose: () => void;
};

const CalendarEvent = ({ event, onClose }: CalendarEventProps) => {
  const { formatMessage: t } = useIntl();
  const styles = useStyles(useTheme());
  const { courseDetailsUrl } = useGlobalContext();

  return (
    <Box maxWidth={400}>
      <Box sx={styles.header}>
        <Box sx={styles.title}>{event.title}</Box>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
      <Box mx={2} mb={1}>
        <Box sx={styles.content}>
          <b>
            {event.eventStartDate &&
              format(event.eventStartDate, "MMMM dd, yyyy " + eventTimeFormat)}
            {" - "}
            {event.eventEndDate && format(event.eventEndDate, eventTimeFormat)}
            {" ("}
            {moment.tz(moment.tz.guess()).zoneAbbr()}
            {")"}
          </b>
        </Box>
        <Box sx={styles.content}>
          <T id="creditHours" />:{" "}
          <CreditsCell value={{ credits: event.credits }} />
        </Box>
        <Box textAlign="center">
          <Link to={courseDetailsUrl(event.id)}>
            <Button variant="contained" fullWidth={false}>
              {t({ id: "moreInformation" })}
            </Button>
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default CalendarEvent;
